export interface iUserInfo {
  token: string
  createTime: number
  tenantCode: string
  userid: string
  currency: string
  username: string
  avatarUrl: string
  id: string
  nickname: string
  guid: string
  phoneNumber: string
  loginTime: number
  status: string
  tfaEnabled: boolean
  tfaType: string
  referralCode: string
  drawType: string
  userLabel: string
  registerIp: string
  vipLevel: number
  smsVerify: boolean
}

export interface iWallet {
  reserve: string
  tenantCode: string
  id: number
  userid: number
  currency: string
  username: string
  balance: number
  rolling: number
  freezing: number
  comment: string
  version: number
  firstDepositAmount: number
  firstDepositTime: string
  firstWithdrawalAmount: number
  firstWithdrawalTime: string
  firstBetAmount: number
  firstBetTime: string
  totalDeposit: number
  totalWithdrawal: number
  totalCashRecharge: number
  totalBonusRecharge: number
  totalBonusDebit: number
  totalReward: number
  totalAgentCommission: number
  totalAgentRebate: number
  totalDepositReward: number
  totalRedeemReward: number
  totalPddReward: number
  totalPwaReward: number
  totalActivationReward: number
  totalRedEnvelopeRainReward: number
  totalRetainReward: number
  totalVipReward: number
  totalLevelReward: number
  totalAidReward: number
  totalSuperWheelReward: number
  totalUserRebateReward: number
  totalInviteeReward: number
  totalTreasureBoxReward: number
  totalDepositBonus: number
  totalBet: number
  totalRolling: number
  totalWinLoss: number
}

export type tCurrency = 'USD' | 'EUR' | 'GBP' | 'CNY' | 'JPY' | 'CAD' | 'AUD' | 'CHF' | 'HKD' | 'NZD' | 'SEK' | 'NOK' | 'DKK' | 'SGD' | 'KRW' | 'THB' | 'INR' | 'RUB' | 'BRL' | 'MXN' | 'ZAR'

export type tTheme = 'theme_a' | 'theme_b' | ''
export type tLang = 'en' | 'pt'

export interface iGameCategory {
  reserve: string
  tenantCode: string
  id: number
  name: string
  icon: string
  customName: string
  customIcon: string
  defaultIcon: string
  showType: string
  sort: number
  count: number
  type: string
  relatedCategory: string
  relatedRoom: string
  rooms: any[]
  homeGames: any[]
  allGames: any[]
}

export enum eShowType {
  Top = 'Top',
  Left = 'Left',
  All = 'All'
}

export enum eCategoryIcon {
  HOT = '/static/images/category/HOT.png',
  SLOTS = '/static/images/category/SLOTS.png',
  FISH = '/static/images/category/FISH.png',
  LIVE = '/static/images/category/LIVE.png',
  MINI = '/static/images/category/MINI.png',
  ARCADE = '/static/images/category/ARCADE.png',
  BINGO = '/static/images/category/BINGO.png',
  RNG = '/static/images/category/RNG.png',
  POKER = '/static/images/category/POKER.png',
}

export interface iGame {
  reserve: string
  tenantCode: string
  id: number
  category: string
  room: string
  code: string
  name: string
  icon: string
  customName: string
  customIcon: string
  rollingRatio: number
  mappingPlatform: string
  mappingCode: string
  strategyBinds: {
    platform: string
    strategyId: number
    name: string
  }[]
}

export interface iRoom {
  reserve: string
  tenantCode: string
  id: number
  name: string
  icon: string
  customName: string
  customIcon: string
  display: string
  categoryId: number
  sort: number
  show: boolean | 1 | 0
}

export type tActivityType = string

export interface iActivity {
  index: number,
  type: string,
  flowType: iFlowType,
  linkName: string,
  id: string,
  activityId: string,
  activityType: string,
  limitType: string,
  status: string,
  activityTimeType: string,
  activityStartTime: string,
  activityEndTime: string,
  resetType: string,
  payOutType: string,
  auditType: string,
  payTimeType: string,
  delay: number,
  expireType: string,
  expireHour: number,
  expireAction: string,
  receiveType: string,
  rollingRatio: number,
  rollingRange: string,
  participateVip: string,
  rewardLimitSms: boolean,
  sort: number,
  bannerUrl: string,
  menuLogo: string,
  exclusive: boolean,
  configJson: string,
  amount: number,
  rewardStatus: tStatus,
  activityConfigName: string,
  activityConfigDesc: string,
  activityConfigLogo: string

  link: string
  name: string
  showRedPoint: boolean
  // linkName: string
  // flowType: string
}

export interface iPromocaoItem {
  id: string
  showRedPoint: boolean
  link: string
  activityType: string
  bannerUrl: string
}

export interface iSuspendIcon {
  configId: number
  picture: string
  language: string[]
  hyperlinkType: string
  hyperlink: string
  jumpMethod: string
  state: string
  activityId: string
  displayCondition: string
  redDotHint: string
  remark: string
  order: number
}

export interface iCarouselMessage {
  configId: number
  rotationContent: string
  language: string[]
  state: string
  remark: string
  order: number
}

export interface iTopDownload {
  configId: number
  asset: string
  language: string[]
  remark: string
  state: string
  order: number
}

export interface iBottomDownload {
  configId: number
  asset: string
  language: string[]
  remark: string
  state: string
  order: number
}

export interface iBottomText {
  configId: number
  text: string
  language: string[]
  state: string
  remark: string
  order: number
}

export interface iBigBanner {
  configId: number
  picture: string
  language: string[]
  hyperlinkType: string
  hyperlink: string
  jumpMethod: string
  state: string
  activityId: number
  remark: string
  order: number
}

export interface iSmallBanner {
  configId: number
  picture: string
  language: string[]
  hyperlinkType: string
  hyperlink: string
  jumpMethod: string
  state: string
  activityId: number
  remark: string
  order: number
}

export interface iPopupImage {
  configId: number
  picture: string
  language: string[]
  hyperlinkType: string
  hyperlink: string
  jumpMethod: string
  state: string
  interval: number
  activityId: number
  remark: string
  order: number
}

export interface iSocialMedia {
  configId: number
  mediaType: string
  defaultIcon: string
  hyperlink: string
  customIcon: string
  isBuoy: boolean
  remark: string
}

export interface iHomeBannersAndTexts {
  suspendIcon: iSuspendIcon | null,
  carouselMessage: iCarouselMessage[],
  topDownload: iTopDownload | null,
  bottomDownload: iBottomDownload | null,
  bottomText: iBottomText | null,
  bigBanner: iBigBanner[],
  smallBanner: iSmallBanner[],
  popupImage: iPopupImage[],
  socialMedia: iSocialMedia[]
}

export interface iServicoItem {
  reserve: string
  tenantCode: string
  id: number
  name: string
  avatar: string
  type: 'OnlineCS' | 'Telegram' | 'Whatsapp' | 'Instagram' | 'Tel'
  account: string
  status: 'Online' | 'Offline'
  sort: number
}

export interface PersistStrategy {
  key?: string
  storage?: Storage
  paths?: string[]
}

// 添加iFlowType类型定义
export type iFlowType =
  | 'AgentCommission'
  | 'AgentRebate'
  | 'DepositReward'
  | 'DepositBonus'
  | 'RedeemReward'
  | 'PddReward'
  | 'PwaReward'
  | 'ActivationReward'
  | 'RedEnvelopeRainReward'
  | 'RetainReward'
  | 'VipReward'
  | 'LevelReward'
  | 'AidReward'
  | 'SuperWheelReward'
  | 'UserRebateReward'
  | 'InviteeReward'
  | 'TreasureBoxReward'
  | 'MysteryBonusReward'

export interface ResponseData<T = any> {
  code: number
  msg: string
  data?: T
  i18n?: string
}

export interface IRequestConfig {
  skipCheck?: boolean
  skipToast?: boolean
  skipTime?: number
  signal?: AbortSignal
}

// 添加从src/api/client.ts中移动的类型
export interface DeviceInfo {
  /** 应用ID */
  applianceId?: string
  /** 渠道ID */
  channelId?: string
  /** 设备号 */
  imei?: string
  /** 机型 */
  model?: string
  /** 浏览器版本 */
  browserVersion?: string
  /** 分辨率 */
  resolution?: string
  /** IP */
  ip?: string
  /** 地区 */
  area?: string
}

export interface RecordParams extends DeviceInfo {
  /** 事件类型 */
  event: EventEnum
  /** 消息通知 */
  notify?: boolean
  /** FCM token */
  token?: string
}

export enum EventEnum {
  /** 进入安装页 */
  EnterPage = 0,
  /** 点击安装应用 */
  ClickButton = 1,
  /** 安装成功 */
  InstallApp = 2,
  /** 打开应用 */
  OpenApp = 3
}

// 添加从src/api/register.ts中移动的类型
export interface iRegisterData {
  nickname?: string;
  organizationId?: number;
  referralCode?: string;
  channelNo?: number;
  username: string;
  password: string;
  avatar?: string;
  activityId?: number;
  activityType?: string;
  loginUserType?: string;
  rewardId?: number;
}

// 添加从src/api/bonus.ts中移动的类型
export type tStatus = 'Unarchived' | 'Awarded' | 'Received' | 'Expired' | 'Invalid' | 'NotInvolved'

export interface iBonusHistoryItem {
  reserve: string
  tenantCode: string
  id: number
  userid: number
  status: tStatus
  activityId: number
  receiveType: string
  rewardId: string
  depositType: string
  rollingRatio: number
  rollingRange: string
  rewardType: string
  depositAmount: number
  depositConfigAmount: number
  rewardAmount: number
  maxRewardAmount: number
}

// 添加从src/api/secretBonus.ts中移动的类型
export interface iDay {
  rewardDay: number
  status: string
  depositAmount: number
  rewardId: number
  rewardAmount: number
  gearlConfigs: iAward[]
}

export interface iAward {
  rewardLevel: number
  depositAmount: number
  showMinAmount: number
  showMaxAmount: number
  betConfigs: iBet[]
}

export interface iBet {
  betMultiple: number
  rewardMinAmount: number
  rewardMaxAmount: number
}

// 添加从src/api/interface.ts中移动的类型
export interface loginRegisterData {
  username: string
  password: string
  avatar?: string | undefined
  inviteCode?: string | undefined
  ch?: string | undefined
  activityId?: string | undefined
  runtime?: string | undefined
  captchaId?: string | undefined
  captchaVal?: string | undefined
  rewardId?: string | undefined
  activityType?: string | undefined
}

export interface overViewData {
  statisticTime?: string
  profitsAmount?: number
  lowerRechargeAmount?: number
  lowerWithdrawalAmount?: number
  lowerBetAmount?: number
  lowerWinLossAmount?: number
}

export interface teamData {
  agentLevel?: number
  agentNum?: number
  amount?: number
}

export interface agentUserInfoData {
  userId?: number
  parentId?: number
  inviteCode?: string
  availableAmount?: number
  withdrawReleased?: boolean
  agentLevel?: number
  teamMember?: number
  directMember?: number
  dailyTeamFlow?: number
  dailyProfits?: number
  receivedAmount?: number
  overview?: overViewData
  myTeam?: teamData[]
}

export interface subAgentItem {
  subUserId?: number
  avatar?: string
  subUserName?: string
  totalRevenue?: number
  profits?: number
}

export interface recordItem {
  collectTime: string | null
  rewardAmount: number
  rewardType: number
}

export interface orderData {
  payType: number | string
  amount: number | string
  giftCode?: string
}

export interface messgaeData {
  id: number
  state: number
  content: string
  createTime: string
  messagePushId: number
}

export interface cashbackData {
  activeUser: number
  firstRechargeAmount: number
  firstRechargeAmountUser: number
  userFlowAmount: number
  userFlowAmountUser: number
}

export interface searchData {
  ch?: string
  pixelId?: string
  type?: string
  inviteCode?: string
  activityId?: string
  platform?: string
}

export interface installConfig {
  id: number
  promoterId?: number
  channelName?: string
  channelDomain?: string
  type?: number
  googleTemplatesId?: null
  pixelId?: string
  apiOral?: string
  button?: number
  install?: number
  presentAmountView?: number
  content?: number
  time?: number
  interval?: number
  apple?: number
  appleLink?: string
  android: number
  apkLink?: string
  giveaway?: number
  presentAmount?: number
  presentLimitAmount?: number
  creator?: string
}

export interface ActivationRemainAwardRecordData {
  id?: number
  userId?: number
  firstRechargeAmount?: number
  remainConfigRecharge?: number
  remainConfigAwardType?: number
  remainConfigAwardAmount?: number
  remainConfigAwardInstalments?: number
  status?: number
  claimedAward?: number
  remainConfigFirstRechargeGet?: number
  createTime?: Date | null | string
  createBy?: string
  updateTime?: Date | null | string
  updaterBy?: string
  remark?: string
  claimedDays?: number
  remainConfigType?: number
  remainConfigTypeLimit?: number
  totalAward?: number
}

export interface ActivationRemainAwardRecordDetailData {
  id?: number
  recordId?: number
  remainConfigType?: number
  remainCompleteDetail?: string
  awardAmount?: number
  limitAmount?: number
  status?: number
  createTime?: string
  createBy?: string
  updateTime?: string
  updateBy?: string
}

export interface ActivationRemainData {
  activationRemainAwardRecord?: ActivationRemainAwardRecordData | null
  activationRemainAwardRecordDetailList?:
    | ActivationRemainAwardRecordDetailData[]
    | null
}

// 添加从src/themes/theme_a目录中找到的类型定义
// 从jiujijin/index.vue
export interface iReliefInfo {
  startTime: string
  endTime: string
  cycleLoss: number
  predictAmount: number
  estimatedTime: string
  amount: number
  rewardConfigs: {
    level: number
    loss: number
    proportion: number
  }[]
  desc: string
  resetType: 'None' | 'Daily' | 'Weekly' | 'Monthly'
  rewardType: 'CashFixed' | 'CashRatio' | 'Scratch' | ''
  awardLimitSms: boolean
}

// 从bonus/index.vue
export interface iBonusActivityInfo {
  depositType: 'First' | 'Single' | 'Accumulate'
  rewardAmount: number
  status: 'Unarchived' | 'Awarded' | 'Received' | 'Expired' | 'Invalid' | 'NotInvolved'
  expireTime: number
  recordCount: number
  rewardId: string
  rewardType: 'CashFixed' | 'CashRatio'
  maxRewardAmount: string
  detailList: {
    status: 'Unarchived' | 'Awarded' | 'Received' | 'Expired' | 'Invalid' | 'NotInvolved'
    depositAmount: number
    startRange: number
    endRange: number
    showMaxAmount: number
    totalRechargeAmount: number
    singleCount: number
  }[]
}

// 从bonus/history/index.vue
export interface iListData {
  total: number
  list: iBonusHistoryItem[]
  pageIndex: number
  finished: boolean
}

// 从Meu/index.vue
export interface iTabItem {
  title: string
  icon: any
  link: string
  count?: number | Ref<number>
}

// 从Deposito/index.vue
export interface iType {
  id: number
  type: string
  minPayeeAmt: number
  maxPayeeAmt: number
  payeeInfoFlag: string
  supportType: string
}

export interface iMerchantConfig {
  tenantCode: string
  id: string
  name: string
  siteName: string
  clientSkin: string
  languages: string[]
  currency: string
  timezone: string
  telephoneAreaCode: string
  level: string
  userDomain: string[]
  adminDomain: string[]
  siteStatus: string
  dataSource: string
  kgRetailId: string
}
